/**
 * Dersdinle'nin kendi PHP/MariaDB API istemcisi.
 *
 * Oturum çerezi tarayıcı tarafından HttpOnly tutulur; JavaScript token görmez.
 * dataClient kullanan ekranlar bu istemciye parça parça taşınırken ortak hata
 * biçimi ve credentials ayarı burada korunur.
 */
const API_BASE = (import.meta.env.VITE_API_URL || (import.meta.env.PROD ? "/api" : "http://localhost:8080/api")).replace(/\/$/, "");

export class DersdinleApiError extends Error {
  readonly status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = "DersdinleApiError";
    this.status = status;
  }
}

type ApiOptions = Omit<RequestInit, "body"> & { body?: unknown };

export async function apiRequest<T>(path: string, options: ApiOptions = {}): Promise<T> {
  const { body, headers, ...init } = options;
  const response = await fetch(`${API_BASE}${path.startsWith("/") ? path : `/${path}`}`, {
    ...init,
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
      ...headers,
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });

  const raw = await response.text();
  let payload: unknown = null;
  try {
    payload = raw ? JSON.parse(raw) : null;
  } catch {
    throw new DersdinleApiError(response.status, "Sunucudan geçersiz bir yanıt alındı.");
  }

  if (!response.ok) {
    const message = payload && typeof payload === "object" && "error" in payload && typeof payload.error === "string"
      ? payload.error
      : "İşlem tamamlanamadı.";
    throw new DersdinleApiError(response.status, message);
  }
  return payload as T;
}

export interface DersdinleUser {
  id: string;
  email: string;
  role: "ogrenci" | "veli" | "ogretmen" | "admin";
  fullName: string;
  gradeLevel?: string | null;
  city?: string | null;
  phone?: string | null;
  birthDate?: string | null;
  user_metadata: Record<string, string>;
}

export const dersdinleAuth = {
  register: (input: {
    email: string; password: string; fullName: string; role: "ogrenci" | "veli" | "ogretmen";
    gradeLevel?: string; city?: string; phone?: string; birthDate?: string;
  }) => apiRequest<{ user: DersdinleUser }>("/auth/register", { method: "POST", body: input }),
  login: (email: string, password: string, otp?: string) => apiRequest<{ user: DersdinleUser }>("/auth/login", { method: "POST", body: { email, password, otp } }),
  me: () => apiRequest<{ user: DersdinleUser }>("/auth/me"),
  logout: () => apiRequest<void>("/auth/logout", { method: "POST" }),
};

export const merakliApi = {
  createPairingCode: (studentUserId?: string) => apiRequest<{ code: string; expires_in: number; student_user_id: string }>(
    "/merakli/pairing-codes", { method: "POST", body: studentUserId ? { student_user_id: studentUserId } : {} },
  ),
};
